import { useCreateTermineFormContext } from '@/domain/termine/features/CreateTermin/shared/useCreateTermineFormContext';
import { useTranslation } from 'react-i18next';

export function CreateTermineSubmitButton() {
  const { t } = useTranslation();
  const { form, isMobile } = useCreateTermineFormContext();

  return (
    <form.AppForm>
      {isMobile ? (
        <form.SubmitButton
          buttonText={t('domain.termine.form.fertig')}
          variant="ghost-primary"
          size="sm"></form.SubmitButton>
      ) : (
        <form.SubmitButton
          buttonText={t('domain.termine.form.fertig')}></form.SubmitButton>
      )}
    </form.AppForm>
  );
}
